<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="queryCondition.sponsorName" placeholder="支持模糊查询" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Farm Group" prop="farmGroup">
                    <el-input v-model="queryCondition.farmGroup" placeholder="支持模糊查询" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="审核员" prop="auditorName">
                    <el-input v-model="queryCondition.auditorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="审核员状态" prop="auditorStatus">
                      <el-select v-model="queryCondition.auditorStatus" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in auditorStatusOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="审批状态" prop="auditStatus">
                      <el-select v-model="queryCondition.auditStatus" clearable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="small" class="btn" type="primary" @click="onAdd" v-acl="RMC_PROD_AUDITOR_ADD">新增</el-button>
        <el-button size="small" class="btn" type="danger" @click="onDel" v-acl="RMC_PROD_AUDITOR_DELETE">删除</el-button>
        <el-button size="small" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROD_AUDITOR_SUBMIT">提交</el-button>
        <el-button size="small" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROD_AUDITOR_APPROVE" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">批准</el-button>
        <el-button size="small" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROD_AUDITOR_RETURN" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">退回</el-button>
        <el-button size="small" class="btn" type="primary" @click="confirmIsUpdate" v-acl="RMC_PROD_AUDITOR_CONFIRM" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!==-1">确认无更新</el-button>
        <el-dropdown split-button type="primary" placement="bottom" v-acl="RMC_PROD_AUDITOR_REPORT,RMC_PROD_AUDITOR_REPORT_QUR">
          报表
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="downloadAuditorLists" v-acl="RMC_PROD_AUDITOR_REPORT">审核员清单</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button class="dropdownItemBtn" size="mini" type="primary" @click="downloadAuditorQuarter" v-acl="RMC_PROD_AUDITOR_REPORT_QUR">审核员清单季度</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div class="btn" v-acl="RMC_PROD_AUDITOR_IMPORT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!==-1">
          <el-upload class="btn" ref="upload" :headers="header" :action="uploadUrl" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :file-list="fileList" :limit="1" :auto-upload="true" :show-file-list="false" v-acl="RMC_PROD_AUDITOR_IMPORT" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!==-1" style="display:inline-block">
            <el-button size="small" type="primary">批量导入</el-button>
          </el-upload>
        </div> -->
        <el-button class="btn" v-acl="RMC_PROD_AUDITOR_IMPORT" size="small" type="primary" @click="onBatchUpload">批量导入</el-button>
        <el-button size="small" class="btn" type="primary" @click="onUpdateLog" v-acl="RMC_PROD_AUDITOR_CHANGE_LOG" v-if="ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">更新日志</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="600" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="Category3" resizable min-width="90" field="category3Name"></ux-table-column>
        <ux-table-column align="center" title="Sponsor" resizable min-width="90" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="Farm Group" resizable min-width="150" field="farmGroup"></ux-table-column>
        <ux-table-column align="center" title="审核员" resizable min-width="90" field="auditorName">
          <template v-slot="{ row }">
            <el-button type="text" @click="onDetail(row)">{{row.auditorName}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="性别" resizable min-width="90" field="auditorGenderView"></ux-table-column>
        <ux-table-column align="center" title="学历" resizable min-width="90" field="auditorEducationView"></ux-table-column>
        <ux-table-column align="center" title="专业" resizable min-width="90" field="auditorMajor"></ux-table-column>
        <ux-table-column align="center" title="从业年限(农业)" resizable min-width="120" field="workYear"></ux-table-column>
        <ux-table-column align="center" title="审核员类型" resizable min-width="120" field="auditorTypeView"></ux-table-column>
        <ux-table-column align="center" title="E-Learning" resizable min-width="120" field="elearningView"></ux-table-column>
        <ux-table-column align="center" title="审核员资质" resizable min-width="120" field="auditorQualificationView"></ux-table-column>
        <ux-table-column align="center" title="MGG管理年限" resizable min-width="120" field="mmgManagerYear"></ux-table-column>
        <ux-table-column align="center" title="审核员状态" resizable min-width="120" field="auditorStatusView"></ux-table-column>
        <ux-table-column align="center" title="状态" resizable min-width="90" field="auditStatusView"></ux-table-column>
        <ux-table-column align="center" title="修改原因" resizable min-width="170" field="updateReason"></ux-table-column>
        <ux-table-column align="center" title="提交人" resizable min-width="90" field="submitName"></ux-table-column>
        <ux-table-column align="center" title="提交日期" resizable min-width="90" field="submitDate"></ux-table-column>
        <ux-table-column align="center" title="审批通过日期" resizable min-width="120" field="approvedDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="更新状态" :visible.sync="dialogUpdateVisible" width="80%" @close="onClose">
      <update-Dialog @onClose="onClose"></update-Dialog>
    </el-dialog>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onCancelReturn" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onCancelReturn">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="选择季度" :visible.sync="dialogQuarterVisible" width="30%" :close-on-click-modal="false" @close="onCancelQuarter">
      <quarterDialog ref="quarterDialog" :type="type" @onCancelQuarter="onCancelQuarter"></quarterDialog>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
      <el-row style="margin-bottom:10px">
        <el-upload ref="batchUpload" :headers="header" :action="uploadUrl" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload" :on-change="handleChange" :file-list="fileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
          <el-button size="small" type="primary">选取文件</el-button>
        </el-upload>
        <el-link type="button" target="_blank" href="static/template/qspi/RMC_Produce_审核员导入模板.xlsx" download="RMC_Produce_审核员导入模板.xlsx">
          <el-button class="btn" type="primary" size="small" style="height:100%">导入模板下载</el-button>
        </el-link>
      </el-row>
      <el-form :model="uploadForm" ref="uploadForm">
        <el-form-item>
          <el-input v-model="uploadForm.fileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <h4>说明:</h4>
        <ul>
          <li>1.请点击模板下载,按照模板填写后再上传</li>
          <li>2.模板中红色字段为必填项,请务必正确填写</li>
          <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
          <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
          <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
        </ul>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import store from '@/store/index'
import IcSelect from "@/components/common/icSelect";
import rmcProdAuditorApi from "@/api/rmcProduce/audit";
import { fileService } from "@/api/common/file-utils";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from "./updateLog.vue"
import quarterDialog from "../public/quarterDialog"
export default {
  name: 'rmcProdAudit',
  mixins: [paginationMixin],
  components: {
    IcSelect,
    updateDialog,
    quarterDialog,
  },
  data() {
    return {
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      multipleSelection: [],
      idList: [],
      category3CodeOptions: [],
      auditorStatusOptions: [],
      auditStatusOptions: [],
      fileList: [],
      tableData: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        category3Code: '',
        sponsorName: '',
        farmGroup: '',
        auditorName: "",
        auditorStatus: 'Effective',
        auditStatus: ''
      },
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: '请输入退回意见', trigger: 'blur' },
        ],
      },
      uploadForm: {
        fileName: "",
      },
      isShow: false,
      dialogUpdateVisible: false,
      dialogReturnVisible: false,
      dialogQuarterVisible: false,
      dialogBatchUploadVisible: false,
      totalCount: 0,
      pages: 1,
      ms_roles: null,
      ms_userId: null,
      type: "",
    }
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('菜类审核员from', from);
    if (from.path === '/qspiTodo' && to.query.sponsorName) {
      to.meta.reqData.sponsorName = to.query.sponsorName
    }
    if (from.path === '/qspiTodo' && to.query.auditStatus) {
      to.meta.reqData.auditStatus = to.query.auditStatus
    }
    if (from.path === '/qspiTodo' && to.query.type && to.query.type !== 'RMC_PRODUCE_AUDITOR_UPDATE') {
      to.meta.reqData.auditorStatus = ''
    } else {
      to.meta.reqData.auditorStatus = 'Effective'
    }
    // if (from.path === '/rmcProdFarmGroup' && to.query.category3Code) {
    //   to.meta.reqData.category3Code = to.query.category3Code
    // }
    // if (from.path === '/rmcProdFarmGroup' && to.query.sponsorName) {
    //   to.meta.reqData.sponsorName = to.query.sponsorName
    // }
    if (from.path === '/rmcProdFarmGroup' && to.query.farmGroup) {
      to.meta.reqData.auditorStatus = ''
      to.meta.reqData.farmGroup = to.query.farmGroup
    }
    rmcProdAuditorApi.getAuditorData(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableData = res.resultData;
        vm.totalCount = res.totalCount;
      })
    })
  },
  computed: {
    uploadUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `rmc/produce/auditor/uploadAuditorList`;
    },
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
  },
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem('ms_roles'))
    this.ms_userId = JSON.parse(localStorage.getItem('ms_userId'))
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    // console.log('ms_roles', this.ms_roles);
    console.log('ms_userId', this.ms_userId);
    // this.queryData()
    this.getSelection()
  },
  methods: {
    queryData() {
      rmcProdAuditorApi.getAuditorData(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        this.$refs.plxTable.reloadData(res.resultData)
      });
    },
    getSelection() {
      rmcProdAuditorApi.getSelection(['rmc.RmcCategory3', 'rmc.RmcAuditorAuditScope', 'rmc.RmcAuditorStatus', 'rmc.RmcAuditStatus']).then(res => {
        console.log('获取下拉框', res);
        this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
          return v.cascadeKey === 'produce'
        })
        this.auditScopeOptions = res.data['rmc.RmcAuditorAuditScope'];
        this.auditorStatusOptions = res.data['rmc.RmcAuditorStatus'];
        this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
        // if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS') !== -1) {
        //   this.auditStatusOptions = res.data['rmc.RmcAuditStatus'].filter(ele => {
        //     return ele.key != "Draft"
        //   })
        // } else {
        //   this.auditStatusOptions = res.data['rmc.RmcAuditStatus'];
        // }
      });
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.idList = []
      val.forEach(ele => {
        this.idList.push(ele.rmcProduceAuditorId)
      })
    },
    onAdd() {
      this.$router.push({
        path: '/rmcProdAuditor/detail',
        query: {
          from: 'add',
          rmcProduceAuditorId: '0'
        }
      })
    },
    onDel() {
      if (this.idList.length == 0) {
        this.$message.error('请先选择数据后再操作');
        return false
      }
      if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS') !== -1) {
        var flag = this.multipleSelection.every(ele => {
          return ele.auditStatus == 'Draft' || ele.auditStatus == 'Approved'
        })
        if (!flag) {
          this.$message.error("已选中的信息不是草稿或者已批准状态，无法删除！");
          return false
        }
      } else {
        var flag = this.multipleSelection.every(ele => {
          return ele.auditStatus == 'Draft' || ele.auditStatus == 'Returned'
        })
        if (!flag) {
          this.$message.error("已选中的信息不是草稿或者退回状态，无法删除！");
          return false
        }
      }
      
      if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS') !== -1) {
        var flag1 = this.multipleSelection.every(ele => {
          return ele.isCqs === 'Y'
        })
        if (!flag1) {
          this.$message.error("审核员清单创建人不属于己方公司的用户，无法维护！");
          return false
        }
      } else if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP') !== -1) {
        var flag2 = this.multipleSelection.every(ele => {
          return ele.isCqs === 'N'
        })
        if (!flag2) {
          this.$message.error("审核员清单创建人不属于己方公司的用户，无法维护！");
          return false
        }
      }
      //您确定要删除所选记录吗？
      this.$confirm('请确认是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'colorBtn',
        cancelButtonClass: 'btn_custom_cancel',
        type: 'warning'
      }).then(() => {
        rmcProdAuditorApi.deleteAuditor({
          rmcProduceAuditorIds: this.idList
        }).then(res => {
          console.log('res', res);
          if (res.meta.code === 200) {
            this.$message.success("删除成功");
            this.queryData()
          }
        });
      })
    },
    beforeUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    uploadSuccess(resp) {
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData();
      } else {
        console.log('resp.meta.msg', resp.meta.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.meta.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
      this.dialogBatchUploadVisible = false
      this.fileList = []
      this.$set(this.uploadForm, "fileName", '')
      this.$refs.batchUpload.clearFiles();
    },
    uploadError(resp) {
      if (undefined != resp.message) {
        let res = JSON.parse(resp.message);
        this.$message.error(res.msg);
      } else {
        this.$message.error("文件上传失败,请检查后重试！");
      }
    },
    handleChange(file, fileList) {
      console.log('file', file);
      console.log('fileList', fileList);
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    onBatchUpload() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    onSubmit() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus !== 'PendingApproval'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态为待审批的单据，无法提交！")
        return false
      }
      if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS') !== -1) {
        var flag1 = this.multipleSelection.every(ele => {
          return ele.isCqs === 'Y'
        })
        if (!flag1) {
          this.$message.error("审核员清单创建人不属于己方公司的用户，无法维护！");
          return false
        }
      } else if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP') !== -1) {
        var flag2 = this.multipleSelection.every(ele => {
          return ele.isCqs === 'N'
        })
        if (!flag2) {
          this.$message.error("审核员清单创建人不属于己方公司的用户，无法维护！");
          return false
        }
      }
      // CQS用户登录，展示按钮：拥有 RMC_PROT_AUDITOR_APPROVE权限 并且 isCqs=‘Y’
      if (this.ms_Permission.indexOf('RMC_PROD_AUDITOR_APPROVE') !== -1) {
        var flag3 = this.multipleSelection.every(ele => {
          return ele.isCqs === 'Y'
        })
        if (!flag3) {
          this.$message.error("无法提交供应商维护的审核员清单，请检查！");
          return false
        }
      } else {
        // 供应商用户登录，展示按钮： 没有RMC_PROT_AUDITOR_APPROVE 权限 并且 isCqs='N'
        var flag4 = this.multipleSelection.every(ele => {
          return ele.isCqs === 'N'
        })
        if (!flag4) {
          this.$message.error("无法提交供应商维护的审核员清单，请检查！");
          return false
        }
      }
      rmcProdAuditorApi.submitBtach({
        rmcProduceAuditorIds: this.idList
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('提交成功')
          this.queryData()
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onApprove() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus == 'PendingApproval'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为待审批的单据，无法批准！")
        return false
      }
      rmcProdAuditorApi.approveAuditor({
        rmcProduceAuditorIds: this.idList
      }).then(res => {
        if (res.meta.code === 200) {
          this.$message.success('批准成功')
          this.$forceUpdate()
          this.queryData()
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    onReturn() {
      if (this.idList.length === 0) {
        this.$message.warning("请先选择数据后再操作")
        return false
      }
      var flag = this.multipleSelection.every(ele => {
        return ele.auditStatus == 'PendingApproval'
      })
      if (!flag) {
        this.$message.warning("页面勾选存在状态不为待审批的单据，无法退回！")
        return false
      }
      this.dialogReturnVisible = true
    },
    onConfirm() {
      this.$refs['returnForm'].validate((valid) => {
        if (valid) {
          rmcProdAuditorApi.returnAuditor({
            rmcProduceAuditorIds: this.idList,
            returnedReason: this.returnForm.returnedReason
          }).then(res => {
            if (res.meta.code === 200) {
              this.$message.success('退回成功')
              this.dialogReturnVisible = false
              this.queryData()
            } else {
              this.$message.error(res.meta.msg)
            }
          })
        }
      })
    },
    onCancelReturn() {
      this.dialogReturnVisible = false
      this.returnForm.returnedReason = ''
    },
    confirmIsUpdate() {
      rmcProdAuditorApi.confirmNoChange().then(res => {
        if (res.meta.code === 200) {
          this.$message.success(res.data)
          this.queryData()
        } else {
          this.$message.error(res.meta.msg)
        }
      })
    },
    downloadAuditorLists() {
      this.$set(this.queryCondition, 'rmcProduceAuditorIds', this.idList)
      rmcProdAuditorApi.downloadAuditorLists(this.queryCondition).then(res => {
        fileService.respToFile(res, 'Produce_审核员清单.xlsx');
        this.$set(this.queryCondition, 'rmcProteinAuditorIds', [])
      })
    },
    downloadAuditorQuarter() {
      this.dialogQuarterVisible = true
      this.type = "produce_auditor"
      this.$refs['quarterDialog'].$refs['quarterForm'].clearValidate()
    },
    onCancelQuarter() {
      this.dialogQuarterVisible = false
      this.$refs['quarterDialog'].$refs['quarterForm'].resetFields()
    },
    onUpdateLog() {
      this.dialogUpdateVisible = true
    },
    onDetail(row) {
      this.$router.push({
        path: '/rmcProdAuditor/detail',
        query: {
          from: 'edit',
          rmcProduceAuditorId: row.rmcProduceAuditorId,
          isCqs: row.isCqs
        }
      })
    },
    onClose() {
      this.dialogBatchVisible = false
      this.queryData()
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
